import familiadosApiClient from '$utils/familiadosApiClient'
import { ResidentDto, DetailedResidentDto } from '$domain/model/nursingHome/residents/residents.model'
import { apiRouter } from '$domain/model/apiRouter'
import { apiErrorService } from '$utils/services/apiErrorService'
import { mapResidentsList, mapDetailedResidentsList } from '$domain/model/nursingHome/residents/residents.mapper'

const recoverResidents = async () => {
  try {
    const residentsListDto = await familiadosApiClient.get<ResidentDto[]>(apiRouter.getResidentsListPath())
    return mapResidentsList(residentsListDto)
  } catch (error) {
    throw apiErrorService.handleError(error)
  }
}

const recoverDetailedResidents = async () => {
  try {
    const detailedResidentsListDto = await familiadosApiClient.get<DetailedResidentDto[]>(
      apiRouter.getDetailedResidentsListPath(),
    )
    return mapDetailedResidentsList(detailedResidentsListDto)
  } catch (error) {
    throw apiErrorService.handleError(error)
  }
}

export const residentsManager = { recoverResidents, recoverDetailedResidents }



// WEBPACK FOOTER //
// ./src/domain/model/nursingHome/residents/residents.manager.ts